<template>
  <div class="wrapper">
    <el-dialog
        title="新增流水"
        :visible.sync="showAdd"
        width="900px"
        class="finance-bill-dialog"
        :before-close="cancelFun"
    >
      <div class="scroll-wrap">
        <el-form ref="form" :model="formData" label-width="130px" class="finance-form">
          <!-- 订单信息区域 -->
          <div class="form-section">
            <div class="section-title">
              <i class="el-icon-document"></i>
              <span>订单信息</span>
            </div>
            <div class="section-content">
              <el-form-item label="订单号" prop="orderNo" :rules="rules">
                <el-input
                    v-model="formData.orderNo"
                    size="small"
                    placeholder="请输入订单号"
                    class="form-input"
                ></el-input>
              </el-form-item>
              <el-form-item label="外部交易号" prop="openTradeNo">
                <el-input
                    v-model="formData.openTradeNo"
                    size="small"
                    placeholder="请输入外部交易号（选填）"
                    class="form-input"
                ></el-input>
              </el-form-item>
            </div>
          </div>

          <!-- 金额信息区域 -->
          <div class="form-section">
            <div class="section-title">
              <i class="el-icon-coin"></i>
              <span>金额信息</span>
            </div>
            <div class="section-content">
              <el-form-item label="金额" prop="amount" :rules="rules">
                <el-input
                    v-model="formData.amount"
                    size="small"
                    placeholder="请输入金额"
                    class="form-input"
                ></el-input>
              </el-form-item>
              <el-form-item label="金额类型" prop="amountType" :rules="rules">
                <el-select
                    v-model="formData.amountType"
                    placeholder="请选择金额类型"
                    size="small"
                    class="form-input"
                >
                  <el-option
                      v-for="item in amountType"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="付款类型" prop="payType" :rules="rules">
                <SelectDict v-model="formData.payType" dictCode="pay:type" :width="'400px'" />
              </el-form-item>
            </div>
          </div>

          <!-- 日期与账期信息区域 -->
          <div class="form-section">
            <div class="section-title">
              <i class="el-icon-calendar"></i>
              <span>日期与账期</span>
            </div>
            <div class="section-content">
              <el-form-item label="应付日期" prop="billDate" :rules="rules">
                <el-date-picker
                    v-model="formData.billDate"
                    value-format="yyyy-MM-dd"
                    size="small"
                    type="date"
                    placeholder="请选择应付日期"
                    class="form-input"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="账期类型" prop="billType" :rules="rules">
                <SelectDict v-model="formData.billType" dictCode="finance:billType" :width="'400px'" />
              </el-form-item>
            </div>
          </div>

          <!-- 其他信息区域 -->
          <div class="form-section">
            <div class="section-title">
              <i class="el-icon-edit-outline"></i>
              <span>其他信息</span>
            </div>
            <div class="section-content">
              <el-form-item label="备注">
                <el-input
                    v-model="formData.remark"
                    type="textarea"
                    :rows="4"
                    size="small"
                    placeholder="请输入备注信息（选填）"
                    class="form-textarea"
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelFun">取 消</el-button>
        <el-button type="primary" size="small" @click="submitFun">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { amountType } from "@/enum/dict/index.js";
import { addFinanceBillAPI } from "./api";
import SelectDict from "@/views/components/select-dict.vue";

export default {
  name: "FinanceBillAdd",
  components: { SelectDict },
  props: {
    showAdd: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      rules: [{ required: true, message: "该项不能为空", trigger: "blur" }],
      formData: {
        orderNo: "",
        amount: "",
        amountType: "",
        payType: "",
        billDate: "",
        billType: "",
        openTradeNo: "",
        remark: "",
      },
      amountType,
    };
  },
  mounted() {},
  methods: {
    submitFun() {
      this.$refs.form.validate(valid => {
        if (valid) {
          addFinanceBillAPI(this.formData).then(() => {
            this.$message.success('添加成功')
            this.$emit("closeDialog", true);
          })
        }
      })
    },
    cancelFun() {
      this.$emit("closeDialog");
    },
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
}

.finance-bill-dialog {
  ::v-deep .el-dialog {
    border-radius: 8px;
    overflow: hidden;
  }

  ::v-deep .el-dialog__header {
    background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
    padding: 20px 24px;
    border-bottom: none;

    .el-dialog__title {
      color: #fff;
      font-size: 18px;
      font-weight: 600;
    }

    .el-dialog__close {
      color: #fff;
      font-size: 20px;

      &:hover {
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }

  ::v-deep .el-dialog__body {
    padding: 24px;
    background: #f5f7fa;
  }

  ::v-deep .el-dialog__footer {
    padding: 16px 24px;
    background: #fff;
    border-top: 1px solid #e4e7ed;
  }

  ::v-deep .el-form-item__label {
    font-weight: 500;
    color: #606266;
    font-size: 14px;
  }

  ::v-deep .el-form-item {
    margin-bottom: 20px;
  }
}

.scroll-wrap {
  max-height: 65vh;
  overflow-y: auto;
  padding-right: 8px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;

    &:hover {
      background: #a8a8a8;
    }
  }
}

.finance-form {
  .form-section {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    overflow: hidden;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    .section-title {
      background: linear-gradient(135deg, #f5f7fa 0%, #e9ecef 100%);
      padding: 14px 20px;
      border-bottom: 2px solid #e4e7ed;
      display: flex;
      align-items: center;
      font-size: 15px;
      font-weight: 600;
      color: #303133;

      i {
        margin-right: 8px;
        font-size: 16px;
        color: #409EFF;
      }
    }

    .section-content {
      padding: 20px 24px;
    }
  }

  .form-input {
    width: 100%;
    max-width: 400px;

    ::v-deep .el-input__inner,
    ::v-deep .el-input__inner {
      border-radius: 4px;
      transition: all 0.3s ease;

      &:focus {
        border-color: #409EFF;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
      }
    }

    ::v-deep .el-input__inner:hover {
      border-color: #c0c4cc;
    }
  }

  .form-textarea {
    width: 100%;
    max-width: 500px;

    ::v-deep .el-textarea__inner {
      border-radius: 4px;
      transition: all 0.3s ease;
      resize: vertical;

      &:focus {
        border-color: #409EFF;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
      }

      &:hover {
        border-color: #c0c4cc;
      }
    }
  }

  ::v-deep .el-select {
    width: 100%;
    max-width: 400px;

    .el-input__inner {
      border-radius: 4px;
      transition: all 0.3s ease;

      &:focus {
        border-color: #409EFF;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
      }

      &:hover {
        border-color: #c0c4cc;
      }
    }
  }

  // SelectDict 组件样式
  ::v-deep .select-dict {
    width: 100%;
    max-width: 400px;

    .el-input__inner {
      border-radius: 4px;
      transition: all 0.3s ease;

      &:focus {
        border-color: #409EFF;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
      }

      &:hover {
        border-color: #c0c4cc;
      }
    }
  }

  ::v-deep .el-date-editor {
    width: 100%;
    max-width: 400px;

    .el-input__inner {
      border-radius: 4px;
      transition: all 0.3s ease;

      &:focus {
        border-color: #409EFF;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
      }
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;

  .el-button {
    padding: 10px 24px;
    border-radius: 4px;
    font-weight: 500;
    transition: all 0.3s ease;

    &.el-button--primary {
      background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
      border: none;

      &:hover {
        opacity: 0.9;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
      }
    }

    &:not(.el-button--primary) {
      &:hover {
        color: #409EFF;
        border-color: #409EFF;
        background-color: #ecf5ff;
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .finance-bill-dialog {
    ::v-deep .el-dialog {
      width: 95% !important;
      margin: 5vh auto;
    }
  }

  .form-input,
  .form-textarea {
    max-width: 100% !important;
  }
}
</style>
